import axios from 'axios';
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.invoicing;

const postInvoice = async (policyHolderId) => {
    let response;
    await axios.post(baseUrl + 'policyholder/' + policyHolderId)
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const getAllInvoices = async () => {
    let response;
    await axios.get(baseUrl + 'get-all-invoices/0/100')
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const getInvoice = async (id) => {
    let response;
    await axios.get(baseUrl + 'invoice/' + id)
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const deleteInvoice = async (id) => {
    let response;
    await axios.delete(baseUrl + 'invoice/' + id)
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const getInvoiceIdNumber = async (idNumber) => {
    let response;
    await axios.get(baseUrl + 'policyholder/invoice-idnum/' + idNumber)
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const getInvoicePolicyNumber = async (policyNumber) => {
    let response;
    await axios.get(baseUrl + 'policyholder/invoice-policynum/' + policyNumber)
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const postInvoiceEmployer = async (id) => {
    let response;
    await axios.post(baseUrl + 'invoice/employer/' + id)
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

export default {
    postInvoiceEmployer, postInvoice, getInvoicePolicyNumber, getInvoiceIdNumber, getInvoice, getAllInvoices,
    deleteInvoice
}